var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "nav",
      {
        staticClass:
          "app-nav navbar mortgage-application-navbar p-0 col col-lg-9",
        attrs: { id: "client-app-nav" },
      },
      [
        _c("locked-application-banner"),
        _vm._v(" "),
        _c("application-navbar", {
          attrs: {
            "current-step": _vm.currentStep,
            "show-menu-toggler": false,
            "invalid-steps": _vm.invalidSteps,
          },
          on: {
            "navigate-next": _vm.goNext,
            "navigate-back": _vm.goPrev,
            "navigate-edit": _vm.goEdit,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "app-standalone pb-5", attrs: { id: "page" } }, [
      _c(
        "div",
        { staticClass: "pt-5 mt-5", attrs: { id: "main-content" } },
        [
          _c("application-quick-actions"),
          _vm._v(" "),
          _c("application-standalone", {
            ref: "applicationStandalone",
            attrs: {
              "application-id": _vm.applicationId,
              "current-step": _vm.currentStep,
              "invalid-steps": _vm.invalidSteps,
              saving: false,
            },
            on: {
              "update:currentStep": function ($event) {
                _vm.currentStep = $event
              },
              "update:current-step": function ($event) {
                _vm.currentStep = $event
              },
              "invalid-step": _vm.handleInvalidStep,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }